module.exports = __webpack_public_path__ + "img/Wolkentupfer.8348732e.svg";